export const NAVBAR_COLLAPSE_BREAKPOINT = 992;
